var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"slide-fade"}},[_c('div',{staticClass:"container",attrs:{"id":"outer"}},[_c('div',{attrs:{"id":"inner"}},[_c('h1',{staticClass:"text-danger"},[_vm._v("Sorry, we don't know this page")])])])])}
var staticRenderFns = []

export { render, staticRenderFns }